import { Injectable, inject, signal, computed, Signal } from '@angular/core';
import { InsertableValue } from '../entities/base/insertable-value';
import { InsertableValueEntity } from '../entities/base/insertable-value-entity';
import { MasterDataRepositoryService } from '../repositories/master-data-repository/master-data-repository.service';
import { finalize } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InsertableValuesStore {
  private masterDataRepo = inject(MasterDataRepositoryService);
  private readonly insertableValuesMap = signal<Record<string, InsertableValue[]>>({});
  private readonly loadingEntities = new Set<string>();

  getInsertableValues(...entities: InsertableValueEntity[]): Signal<InsertableValue[]> {
    for (const entity of entities) {
      this.loadInsertableValues(entity);
    }
    return computed(() => {
      const map = this.insertableValuesMap();
      return entities.flatMap(entity => map[entity] ?? []);
    });
  }

  private loadInsertableValues(entity: InsertableValueEntity): void {
    if (this.loadingEntities.has(entity) || this.insertableValuesMap()[entity]) return;
    this.loadingEntities.add(entity);

    this.masterDataRepo.insertableValues(entity).pipe(
      finalize(() => this.loadingEntities.delete(entity))
    ).subscribe({
      next: values => {
        this.insertableValuesMap.update(map => ({ ...map, [entity]: values }));
      },
      error: err => {
        console.warn(`Failed to load insertable values for entity "${entity}". Will retry on next request.`, err);
      }
    });
  }
}
